.truthLabel {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  padding: var(--space-1) var(--space-2);
  min-height: 24px;
  max-width: 100%;
  border-radius: var(--radius-small);
  background: var(--color-bg-subtle);
  color: var(--color-content-secondary);
  font: var(--type-label);
  font-weight: 500;
  vertical-align: middle;
}

.compact {
  padding: 2px var(--space-1);
  min-height: 20px;
}

.truthShape {
  flex: none;
  line-height: 1;
  font-size: 0.8em;
}

.truthText {
  line-height: 1.4;
}

.truthLabel[data-state='ANALYST_VERIFIED'],
.truthLabel[data-state='COMPLETED'],
.truthLabel[data-state='FIXED'] {
  color: var(--color-positive-content);
  background: var(--color-positive-surface);
}

.truthLabel[data-state='STILL_VULNERABLE'],
.truthLabel[data-state='CRITICAL'],
.truthLabel[data-state='HIGH'],
.truthLabel[data-state='FAILED'],
.truthLabel[data-state='BLOCKED'] {
  color: var(--color-negative-content);
  background: var(--color-negative-surface);
}

/* Remediation complete is a workflow state, not proof of a fix (DESIGN_SYSTEM.md §5.3, §10.7). */
.truthLabel[data-dimension='remediation'][data-state='COMPLETED'] {
  color: var(--color-content-secondary);
  background: var(--color-bg-subtle);
}

.truthLabel[data-state='CRITICAL'],
.truthLabel[data-kind='attention'],
.truthLabel[data-state='RUNNING'] {
  font-weight: 600;
}
